import { Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ContentContainer } from '@/components/shell/ContentContainer';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/stores/authStore';
import { STRINGS } from '@/strings/strings';

const SUPPORT_EMAIL = 'support@dreamable.kids';

/**
 * A-16 Datenexport (Batch 9C — Mai-Launch Support-Email-Fallback per
 * Briefing line 583-595).
 *
 * The DSGVO Art. 20 self-service export is a Phase 7+ scope item.
 * For Mai-Launch, the page just renders a brand-voiced explanation +
 * a `mailto:` CTA that prefills subject + body with the user's email
 * interpolated (per Flag 6 — email is friendlier than UUID, support
 * workflow runs via email anyway).
 */
export function ExportRoute() {
  const navigate = useNavigate();
  const userEmail = useAuthStore((s) => s.user?.email ?? '');

  const S = STRINGS.account.export;

  const subject = encodeURIComponent(S.mailtoSubject);
  const body = encodeURIComponent(S.mailtoBodyTemplate.replace('{email}', userEmail));
  const mailtoHref = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;

  return (
    <div className="min-h-screen bg-dream-white">
      <ContentContainer maxWidth="narrow">
        <div className="py-6">
          <button
            type="button"
            onClick={() => navigate('/account')}
            className="mb-4 text-sm text-dream-navy/70 hover:text-dream-navy transition-colors"
          >
            {S.back}
          </button>

          <h1 className="text-[22px] font-semibold text-dream-navy mb-4">{S.title}</h1>

          <p className="text-sm text-dream-navy mb-4 leading-relaxed">{S.body}</p>

          <p className="text-sm text-dream-navy/70 mb-6 leading-relaxed">{S.hint}</p>

          <Button
            asChild
            className="w-full h-12 text-base font-semibold"
            data-testid="export-mailto-cta"
          >
            <a href={mailtoHref}>
              <Mail className="w-4 h-4" />
              {S.cta}
            </a>
          </Button>
        </div>
      </ContentContainer>
    </div>
  );
}
